import { createSlice } from "@reduxjs/toolkit";
const AuthSlice = createSlice({
  name: "User",
  initialState: {
    user: {},
    auth: false,
  },
  reducers: {
    login: (state: any, action: any) => {
      state.user = action.payload;
      state.auth = true;
    },
    logout: (state, action) => {
      state.user = {};
      state.auth = false;
    },
    update: (state: any, action: any) => {
      state.user.data = action.payload;
    },
  },
});

export const { login, logout, update } = AuthSlice.actions;
export default AuthSlice;
